import { AxiosResponse } from 'axios';
import axiosApi from '../api/axios-api';

export default {
	consoGroupCompanyCheckExistByCWK(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/consogroupcompany/checkexistbycwk`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
};
